<template>
  <div class="index-other-item-page">
    <div v-for="(item,index) in courses" :key="index" class="ii-item" @click="goPage(item)">
      <img class="course-cover cover" :src="item.cover_img" alt />
      <div class="ii-content">
        <p class="ii-title">
          <span class="vip-icon" v-if="item.is_vip">会员</span>
          <span class="quan-icon" v-if="item.is_has_coupon">券</span>
          <font>{{item.title}}</font>
        </p>
        <p class="ii-info">
          <!-- 1、价格为：xxxx.yz（其中y不为0，z不为0）时 ，则显示为：xxxx.yz;
            2、价格为：xxxx.yz（其中y不为0，z为0）时 ，则显示为：xxxx.y；
            3、价格为：xxxx.yz（其中y为0，z不为0）时 ，则显示为：xxxx.yz；
            4、价格为：xxxx.yz（其中y为0，z为0）时 ，则显示为：xxxx；
          5、价格整数部分超过五位数时，如价格为abcdef，则显示为ab.cd万，不用四舍五入-->
          <span class="person">
            <span v-if="item.course_type != 4">{{item.sales_num > 9999 ? '1万+':item.sales_num}}人已报名</span>
            <span v-else-if="item.brows_num">{{item.brows_num > 9999 ? '1万+':item.brows_num}}人已报名</span>
          </span>
          <font class="through" v-if="item.underlined_price">
            <icon-price size="mini"></icon-price>
            <template
              v-if="item.underlined_price > 999999"
            >{{item.underlined_price/1000000 | toFixPrice(-1)}}万</template>
            <template v-else>{{item.underlined_price | toFixPrice(0)}}</template>
          </font>
          <font class="price" v-if="item.price">
            <icon-price size="mini"></icon-price>
            <font v-if="item.price > 999999">{{item.price/1000000 | toFixPrice(-1)}}万</font>
            <font v-else>{{item.price | toFixPrice(0)}}</font>
          </font>
          <font class="free" v-else>免费</font>
        </p>
        <i class="has-buy" v-if="item.has_buy"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexItem",
  props: {
    course: {
      type: Array
    },
    itemStyle: {
      type: Boolean,
      default: false
    },
    system: {
      default: 0
    }
  },
  computed: {
    courses() {
      let arr = [];
      if (this.course && this.course.length > 0) {
        arr = this.course;
        arr.forEach(item => {
          let startDay = new Date(item.start_play_date * 1000).getDate();
          let endDay = new Date(item.end_play_date * 1000).getDate();
          if (startDay != endDay) {
            item.showTime = 1;
          } else {
            item.showTime = 2;
          }
        });
      }
      return arr;
    }
  },
  data() {
    return {
      List: [],
      noTime: [5, 8, 9, 10]
    };
  },
  methods: {
    async goPage(item) {
      // 公开课
      if (item.course_type == 4) {
        //   公开
        let info = await this.$http.get(
          `/api/app/getPcRoomCode/course_id=${item.id}/chapter_id=0`
        );
        this.$router.push({
          name: "LivePlay",
          query: {
            course_id: item.id,
            chapter_id: 0
          }
        });
      } else {
        this.$pub.InAppPage("CourseDetail", {
          id: item.id,
          courseType: item.course_type,
          system_course_id: this.$route.query.id
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index-other-item-page {
  padding: 30px;
  .ii-item {
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    padding: 30px 20px;
    margin-bottom: 30px;
    display: flex;
    position: relative;
    .has-buy {
      position: absolute;
      right: 10px;
      top: 50px;
      background: url("~@/assets/images/has-buy.png") no-repeat;
      background-size: 100% 100%;
      width: 98px;
      height: 78px;
    }
    .course-cover {
      flex: none;
      width: 232px;
      height: 136px;
      margin-right: 20px;
    }
    .ii-content {
      display: flex;
      width: 400px;
      height: 136px;
      flex-direction: column;
      justify-content: space-between;
      .ii-title {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 36px;
        margin-top: -4px;
        .vip-icon {
          width: 64px;
          height: 34px;
          border-radius: 4px;
          background: rgba(238, 31, 31, 0.1);
          margin-right: 10px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
          line-height: 34px;
          display: inline-block;
          text-align: center;
          vertical-align: 3px;
        }
        .quan-icon {
          width: 34px;
          height: 34px;
          border-radius: 4px;
          background: #e74d3d;
          margin-right: 10px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 34px;
          display: inline-block;
          text-align: center;
          vertical-align: 3px;
        }
        font {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(32, 36, 42, 1);
        }
      }
      .ii-info {
        display: flex;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        align-items: flex-end;
        span {
          // padding-right: 20px;
          color: rgba(0, 0, 0, 0.45);
        }
        .person {
          flex: 1;
        }
        .through {
          text-decoration: line-through;
          color: #999999;
          // margin-right: 10px;
          font-size: 22px;
        }
        .price {
          color: #ee1f1f;
          font-size: 30px;
        }
        .free {
          color: #44a426;
          font-size: 30px;
        }
      }
    }
  }
}
</style>
